// Firebase configuration and initialization
import { initializeApp } from 'firebase/app';
import { getAnalytics, logEvent } from 'firebase/analytics';

// Firebase configuration from environment variables
const firebaseConfig = {
  apiKey: process.env.REACT_APP_FIREBASE_API_KEY,
  authDomain: process.env.REACT_APP_FIREBASE_AUTH_DOMAIN,
  projectId: process.env.REACT_APP_FIREBASE_PROJECT_ID,
  storageBucket: process.env.REACT_APP_FIREBASE_STORAGE_BUCKET,
  messagingSenderId: process.env.REACT_APP_FIREBASE_MESSAGING_SENDER_ID,
  appId: process.env.REACT_APP_FIREBASE_APP_ID,
  measurementId: process.env.REACT_APP_FIREBASE_MEASUREMENT_ID
};

// Initialize Firebase
const app = initializeApp(firebaseConfig);

// Initialize Analytics (only in browser environment)
let analytics = null;
if (typeof window !== 'undefined') {
  analytics = getAnalytics(app);
}

// Analytics helper functions
export const trackEvent = (eventName, eventParams = {}) => {
  if (analytics) {
    logEvent(analytics, eventName, eventParams);
  }
};

// Pre-defined events for the Ad Campaign Generator
export const trackPageView = (pageName) => {
  trackEvent('page_view', { page_name: pageName });
};

export const trackLogin = (method = 'google') => {
  trackEvent('login', { method });
};

export const trackSignUp = (method = 'google') => {
  trackEvent('sign_up', { method });
};

export const trackCampaignCreated = (adType, tone) => {
  trackEvent('campaign_created', { 
    ad_type: adType, 
    tone: tone 
  });
};

export const trackImageGenerated = (adType, aspectRatio) => {
  trackEvent('image_generated', { 
    ad_type: adType, 
    aspect_ratio: aspectRatio 
  });
};

export const trackCreditsUsed = (amount, action) => {
  trackEvent('credits_used', { 
    amount: amount, 
    action: action 
  });
};

export const trackCreditsPurchased = (plan, amount) => {
  trackEvent('credits_purchased', { 
    plan: plan, 
    amount: amount 
  });
};

export const trackCopiedContent = (contentType) => {
  trackEvent('content_copied', { 
    content_type: contentType 
  });
};

export const trackFeedbackSubmitted = (feedbackType) => {
  trackEvent('feedback_submitted', { 
    feedback_type: feedbackType 
  });
};

export { app, analytics };
